// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file ai_color_simulation/v1/process_image.proto (package ai_color_simulation.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ai_color_simulation/v1/process_image.proto.
 */
export const file_ai_color_simulation_v1_process_image: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message ai_color_simulation.v1.CreateProcessImageDealRequest
 */
export type CreateProcessImageDealRequest = Message<"ai_color_simulation.v1.CreateProcessImageDealRequest"> & {
  /**
   * 画像の入力方法（S3パスまたは直接のバイナリデータ）
   *
   * @generated from oneof ai_color_simulation.v1.CreateProcessImageDealRequest.payload
   */
  payload: {
    /**
     * S3などのファイルパス go apiで使用
     *
     * @generated from field: string s3_path = 1;
     */
    value: string;
    case: "s3Path";
  } | {
    /**
     * 画像の生データ・ローカルのstorybookで使用
     *
     * @generated from field: bytes raw_image = 2;
     */
    value: Uint8Array;
    case: "rawImage";
  } | { case: undefined; value?: undefined };

  /**
   * 案件ID（パス構造に使用）
   *
   * @generated from field: int64 deal_id = 3;
   */
  dealId: bigint;
};

/**
 * Describes the message ai_color_simulation.v1.CreateProcessImageDealRequest.
 * Use `create(CreateProcessImageDealRequestSchema)` to create a new message.
 */
export const CreateProcessImageDealRequestSchema: GenMessage<CreateProcessImageDealRequest> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_process_image, 0);

/**
 * @generated from message ai_color_simulation.v1.UploadProcessImageRequest
 */
export type UploadProcessImageRequest = Message<"ai_color_simulation.v1.UploadProcessImageRequest"> & {
  /**
   * 画像の入力方法（S3パスまたは直接のバイナリデータ）
   *
   * @generated from oneof ai_color_simulation.v1.UploadProcessImageRequest.payload
   */
  payload: {
    /**
     * S3などのファイルパス go apiで使用
     *
     * @generated from field: string s3_path = 1;
     */
    value: string;
    case: "s3Path";
  } | {
    /**
     * 画像の生データ・ローカルのstorybookで使用
     *
     * @generated from field: bytes raw_image = 2;
     */
    value: Uint8Array;
    case: "rawImage";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: int64 deal_id = 3;
   */
  dealId: bigint;

  /**
   * AIカラープロジェクトID(ULID)。deal非依存フローで使用 (issue #1828)
   *
   * @generated from field: string ai_color_project_id = 4;
   */
  aiColorProjectId: string;
};

/**
 * Describes the message ai_color_simulation.v1.UploadProcessImageRequest.
 * Use `create(UploadProcessImageRequestSchema)` to create a new message.
 */
export const UploadProcessImageRequestSchema: GenMessage<UploadProcessImageRequest> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_process_image, 1);

/**
 * 画像色変更処理のレスポンス
 *
 * @generated from message ai_color_simulation.v1.UploadProcessImageResponse
 */
export type UploadProcessImageResponse = Message<"ai_color_simulation.v1.UploadProcessImageResponse"> & {
  /**
   * 処理済み画像のS3パス
   *
   * @generated from field: string s3_path = 1;
   */
  s3Path: string;

  /**
   * 一時加工済み画像のS3パス
   *
   * @generated from field: string cleaned_image_s3_path = 2;
   */
  cleanedImageS3Path: string;

  /**
   * @generated from field: int64 deal_id = 3;
   */
  dealId: bigint;

  /**
   * AIカラープロジェクトID(ULID)。deal非依存フローで使用 (issue #1828)
   *
   * @generated from field: string ai_color_project_id = 4;
   */
  aiColorProjectId: string;

  /**
   * アップロードの課金元（design-6.6-notifications.md §2）
   *
   * @generated from field: ai_color_simulation.v1.CreditSource credit_source = 5;
   */
  creditSource: CreditSource;
};

/**
 * Describes the message ai_color_simulation.v1.UploadProcessImageResponse.
 * Use `create(UploadProcessImageResponseSchema)` to create a new message.
 */
export const UploadProcessImageResponseSchema: GenMessage<UploadProcessImageResponse> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_process_image, 2);

/**
 * deal を作らず ai_color_projects を作成し、画像を一次加工して保存する (issue #1828)
 *
 * @generated from message ai_color_simulation.v1.CreateProcessImageProjectRequest
 */
export type CreateProcessImageProjectRequest = Message<"ai_color_simulation.v1.CreateProcessImageProjectRequest"> & {
  /**
   * 画像の入力方法（S3パスまたは直接のバイナリデータ）
   *
   * @generated from oneof ai_color_simulation.v1.CreateProcessImageProjectRequest.payload
   */
  payload: {
    /**
     * S3などのファイルパス go apiで使用
     *
     * @generated from field: string s3_path = 1;
     */
    value: string;
    case: "s3Path";
  } | {
    /**
     * 画像の生データ・ローカルのstorybookで使用
     *
     * @generated from field: bytes raw_image = 2;
     */
    value: Uint8Array;
    case: "rawImage";
  } | { case: undefined; value?: undefined };

  /**
   * プロジェクト名（空ならサーバ側で日付ベースの既定名）
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 既存顧客をアサイン（0=なし）。優先される
   *
   * @generated from field: int64 customer_id = 4;
   */
  customerId: bigint;

  /**
   * customer_id==0 かつ非空なら新規顧客を作成して紐付け
   *
   * @generated from field: string new_customer_name = 5;
   */
  newCustomerName: string;

  /**
   * 案件起点で作る場合の案件ID（0=案件に紐付けない）。
   * 非0のときはプロジェクトを作成時点でこの案件に連携済みにし、顧客は案件の顧客を使う
   * （customer_id / new_customer_name は無視される）。AIカラーは案件を必須にしないが、
   * 案件から入った場合は連携済みで作る（2026-09-17 藤井の決定）。
   *
   * @generated from field: int64 deal_id = 6;
   */
  dealId: bigint;
};

/**
 * Describes the message ai_color_simulation.v1.CreateProcessImageProjectRequest.
 * Use `create(CreateProcessImageProjectRequestSchema)` to create a new message.
 */
export const CreateProcessImageProjectRequestSchema: GenMessage<CreateProcessImageProjectRequest> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_process_image, 3);

/**
 * @generated from message ai_color_simulation.v1.CreateProcessImageProjectResponse
 */
export type CreateProcessImageProjectResponse = Message<"ai_color_simulation.v1.CreateProcessImageProjectResponse"> & {
  /**
   * 処理済み画像のS3パス
   *
   * @generated from field: string s3_path = 1;
   */
  s3Path: string;

  /**
   * 一時加工済み画像のS3パス
   *
   * @generated from field: string cleaned_image_s3_path = 2;
   */
  cleanedImageS3Path: string;

  /**
   * 作成された AIカラープロジェクトID(ULID)
   *
   * @generated from field: string ai_color_project_id = 3;
   */
  aiColorProjectId: string;

  /**
   * アップロードの課金元（design-6.6-notifications.md §2）
   *
   * @generated from field: ai_color_simulation.v1.CreditSource credit_source = 4;
   */
  creditSource: CreditSource;
};

/**
 * Describes the message ai_color_simulation.v1.CreateProcessImageProjectResponse.
 * Use `create(CreateProcessImageProjectResponseSchema)` to create a new message.
 */
export const CreateProcessImageProjectResponseSchema: GenMessage<CreateProcessImageProjectResponse> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_process_image, 4);

/**
 * マスク生成処理のリクエスト (v2)
 *
 * @generated from message ai_color_simulation.v1.GenerateMaskRequest
 */
export type GenerateMaskRequest = Message<"ai_color_simulation.v1.GenerateMaskRequest"> & {
  /**
   * 画像の入力方法（S3パスまたは直接のバイナリデータ）
   *
   * @generated from oneof ai_color_simulation.v1.GenerateMaskRequest.payload
   */
  payload: {
    /**
     * S3などのファイルパス
     *
     * @generated from field: string s3_path = 1;
     */
    value: string;
    case: "s3Path";
  } | {
    /**
     * 画像の生データ
     *
     * @generated from field: bytes raw_image = 2;
     */
    value: Uint8Array;
    case: "rawImage";
  } | { case: undefined; value?: undefined };

  /**
   * ファイル名（raw_image使用時に必要）
   *
   * @generated from field: string image_filename = 3;
   */
  imageFilename: string;

  /**
   * 生成するマスクタイプ（並列リクエスト用）
   *
   * @generated from field: ai_color_simulation.v1.MaskType mask_type = 4;
   */
  maskType: MaskType;

  /**
   * 案件ID（パス構造に使用）
   *
   * @generated from field: int64 deal_id = 5;
   */
  dealId: bigint;

  /**
   * AIカラープロジェクトID(ULID)。deal非依存フローで使用 (issue #1828)
   *
   * @generated from field: string ai_color_project_id = 6;
   */
  aiColorProjectId: string;

  /**
   * 再生成時にマスクを紐づけるベース画像の DB ID。0 = 従来挙動（Go 側で DB 保存しない）
   *
   * @generated from field: int64 base_color_simulation_image_id = 7;
   */
  baseColorSimulationImageId: bigint;

  /**
   * true = 再生成モード。Python 側で seed 無指定（ランダム）+ GEMINI_REGEN_TEMPERATURE (default 1.0) を適用
   *
   * @generated from field: bool regenerate = 8;
   */
  regenerate: boolean;
};

/**
 * Describes the message ai_color_simulation.v1.GenerateMaskRequest.
 * Use `create(GenerateMaskRequestSchema)` to create a new message.
 */
export const GenerateMaskRequestSchema: GenMessage<GenerateMaskRequest> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_process_image, 5);

/**
 * マスク生成に実際に使用されたパラメータ（再生成履歴の知識蓄積用に DB 保存される）
 *
 * @generated from message ai_color_simulation.v1.MaskGenerationParams
 */
export type MaskGenerationParams = Message<"ai_color_simulation.v1.MaskGenerationParams"> & {
  /**
   * 使用モデル名（例: gemini-3-pro-image）
   *
   * @generated from field: string model_name = 1;
   */
  modelName: string;

  /**
   * 実際に適用した temperature
   *
   * @generated from field: double temperature = 2;
   */
  temperature: number;

  /**
   * seed をリクエスト config に載せたか（モデル非対応時や regenerate 時は false）
   *
   * @generated from field: bool seed_applied = 3;
   */
  seedApplied: boolean;

  /**
   * seed_applied=true のときの seed 値
   *
   * @generated from field: int64 seed = 4;
   */
  seed: bigint;

  /**
   * 再生成モードだったか
   *
   * @generated from field: bool regenerate = 5;
   */
  regenerate: boolean;
};

/**
 * Describes the message ai_color_simulation.v1.MaskGenerationParams.
 * Use `create(MaskGenerationParamsSchema)` to create a new message.
 */
export const MaskGenerationParamsSchema: GenMessage<MaskGenerationParams> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_process_image, 6);

/**
 * マスク生成処理のレスポンス (v2)
 *
 * @generated from message ai_color_simulation.v1.GenerateMaskResponse
 */
export type GenerateMaskResponse = Message<"ai_color_simulation.v1.GenerateMaskResponse"> & {
  /**
   * 外壁用マスク済み画像のS3パス
   *
   * @generated from field: string masked_wall_s3_path = 1;
   */
  maskedWallS3Path: string;

  /**
   * 屋根用マスク済み画像のS3パス
   *
   * @generated from field: string masked_roof_s3_path = 2;
   */
  maskedRoofS3Path: string;

  /**
   * 後方互換用（wallと同じ内容）
   *
   * @generated from field: string masked_image_s3_path = 3 [deprecated = true];
   * @deprecated
   */
  maskedImageS3Path: string;

  /**
   * 雨樋用マスク済み画像のS3パス
   *
   * @generated from field: string masked_gutter_s3_path = 4;
   */
  maskedGutterS3Path: string;

  /**
   * 破風・鼻隠し用マスク済み画像のS3パス
   *
   * @generated from field: string masked_fascia_s3_path = 5;
   */
  maskedFasciaS3Path: string;

  /**
   * 生成に使用された実パラメータ
   *
   * @generated from field: ai_color_simulation.v1.MaskGenerationParams generation_params = 6;
   */
  generationParams?: MaskGenerationParams;
};

/**
 * Describes the message ai_color_simulation.v1.GenerateMaskResponse.
 * Use `create(GenerateMaskResponseSchema)` to create a new message.
 */
export const GenerateMaskResponseSchema: GenMessage<GenerateMaskResponse> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_process_image, 7);

/**
 * AI機能の課金元種別（plan-restructure-2026-10 R6 tasks 6.6）
 * 設計の経緯: openspec/changes/archive/2026-10-07-plan-restructure-2026-10/design-6.6-notifications.md §2
 *
 * api_proto.v1.CreditSource（api_proto/v1/credit.proto）と同じ値を持つ独立した enum。
 * api_proto/v1/ai_color_simulation.proto が既に ai_color_simulation/v1 の message を
 * import しており（Go の api_proto/v1 → ai_color_simulation/v1）、逆方向の import は
 * Go package import cycle になるため（doc/coding_rules/proto.md「proto パッケージ間
 * import の依存方向」）、共通化はせずパッケージごとに定義する。
 * 値は Python 側では設定しない（未指定のまま返る）。Go ハンドラが Python 呼び出し後に
 * クレジットチケットの判定結果で上書きしてから frontend へ返す。
 *
 * @generated from enum ai_color_simulation.v1.CreditSource
 */
export enum CreditSource {
  /**
   * 未指定（後方互換のデフォルト値）
   *
   * @generated from enum value: CREDIT_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * クレジット制御が無効、または記録モードで実際には課金されていない
   *
   * @generated from enum value: CREDIT_SOURCE_NONE = 1;
   */
  NONE = 1,

  /**
   * 無料体験ロット（grant_source=trial）から充当された
   *
   * @generated from enum value: CREDIT_SOURCE_TRIAL = 2;
   */
  TRIAL = 2,

  /**
   * 契約付与ロットから充当された
   *
   * @generated from enum value: CREDIT_SOURCE_CONTRACT = 3;
   */
  CONTRACT = 3,
}

/**
 * Describes the enum ai_color_simulation.v1.CreditSource.
 */
export const CreditSourceSchema: GenEnum<CreditSource> = /*@__PURE__*/
  enumDesc(file_ai_color_simulation_v1_process_image, 0);

/**
 * マスク生成処理で指定するマスクタイプ (v2)
 *
 * @generated from enum ai_color_simulation.v1.MaskType
 */
export enum MaskType {
  /**
   * 指定なし（すべて生成）
   *
   * @generated from enum value: MASK_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 外壁のみ
   *
   * @generated from enum value: MASK_TYPE_WALL = 1;
   */
  WALL = 1,

  /**
   * 屋根のみ
   *
   * @generated from enum value: MASK_TYPE_ROOF = 2;
   */
  ROOF = 2,

  /**
   * 雨樋のみ
   *
   * @generated from enum value: MASK_TYPE_GUTTER = 3;
   */
  GUTTER = 3,

  /**
   * 破風・鼻隠しのみ
   *
   * @generated from enum value: MASK_TYPE_FASCIA = 4;
   */
  FASCIA = 4,
}

/**
 * Describes the enum ai_color_simulation.v1.MaskType.
 */
export const MaskTypeSchema: GenEnum<MaskType> = /*@__PURE__*/
  enumDesc(file_ai_color_simulation_v1_process_image, 1);

